import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {

  constructor() {
  }
}
